export default "__VITE_ASSET__BUtMRylb__"